module.exports = __webpack_public_path__ + "static/media/greyRemove.779be3d8.svg";